module.exports = __webpack_public_path__ + "static/what-we-do-banner-image-d8d5c65f7b22f3bede070302aaff742a.png";